import autocompleteClasses from "@mui/material/Autocomplete/autocompleteClasses";
import { button } from "../../styles/utils/button.module";
import { MuiButtonTheme } from "../Button/Button.theme";
export const MuiIconButtonTheme = (dt) => {
    const iconButtonTheme = MuiButtonTheme(dt) ? MuiButtonTheme(dt) : {};
    const so = iconButtonTheme.styleOverrides ? iconButtonTheme.styleOverrides : {};
    iconButtonTheme.defaultProps = {
        disableRipple: true,
    };
    so.root = Object.assign(Object.assign({}, button(dt.cta.outlined, ["neutral"], dt)), { borderWidth: 0, borderRadius: dt.button.shape.borderRadius });
    so.root[`&.${autocompleteClasses.clearIndicator}`] = Object.assign(Object.assign({}, button(dt.cta.outlined, ["neutral"], dt)), { borderRadius: dt.borderRadius.pill, "&:focus, &:is(.Pxl-demo-focus, [data-demostate=focus])": {
            boxShadow: "",
        } });
    so.sizeSmall = {
        "&": {
            width: dt.button.small,
            height: dt.button.small,
            ".PixelIcon": {
                width: dt.icon.size.small,
                height: dt.icon.size.small,
            },
        },
    };
    so.sizeMedium = {
        "&": {
            width: dt.button.medium,
            height: dt.button.medium,
            ".PixelIcon": {
                width: dt.icon.size.medium,
                height: dt.icon.size.medium,
            },
        },
    };
    so.sizeLarge = {
        "&": {
            width: dt.button.large,
            height: dt.button.large,
            ".PixelIcon": {
                width: dt.icon.size.large,
                height: dt.icon.size.large,
            },
        },
    };
    return iconButtonTheme;
};
